(function ($) {
	const isWelcomePage = $("body").hasClass("welcome-page");
	if (!isWelcomePage) return false;

	const elms = {
		btnSetupProfile: ".js-setup-profile",
		avatarUpload: ".js-avatar-upload",
		inputAvatar: ".js-avatar",
		inputNickname: ".js-nickname",
		submit: ".js-submit-avatar",
	};

	const goToNextScreen = function (e) {
		const goToSetupProfile = function () {
			e.preventDefault();

			bdjs.showLoading(function () {
				$(".gameScreen")
					.removeClass("is-active")
					.filter("#setupScreen")
					.addClass("is-active");

				setTimeout(() => {
					bdjs.hideLoading();
				}, 300);
			});
		};

		const goToStartGame = function () {
			bdjs.showLoading(() => {
				bdapi
					.post("member/start-game-without-setup-profile")
					.then((response) => {
						const status = response.status;
						const data = response.data.data;

						console.log(response);

						if (data.redirect) {
							window.location.href = data.redirect;
							return false;
						}
					})
					.catch((error) => {
						console.log(error);
					});
			})
		};

		$(this).addClass('is-loading');
		const usingAvatarSetup = $(this).attr("data-using-avatar-setup") == 1;
		if (usingAvatarSetup) {
			goToSetupProfile();
		} else {
			goToStartGame();
		}
	};

	$(elms.btnSetupProfile).on("click", goToNextScreen);

	/* SETUP AVATAR */
	let $displayEl = $(`.display-img`);

	if ($displayEl.attr("src") === "") {
		$displayEl.hide();
	}

	function readURL(input) {
		if (input.files && input.files[0]) {
			var reader = new FileReader();
			reader.onload = function (e) {
				$displayEl.attr("src", e.target.result);
			};
			reader.readAsDataURL(input.files[0]);
		}
	}

	$(elms.inputAvatar)
		.change(function () {
			let $selectedAvatar = $(`${elms.inputAvatar}:checked`);
			const urlImg = $selectedAvatar.siblings("#avatarIcon").attr("src");

			const $avatars = $(elms.inputAvatar);
			$avatars.parent().removeClass("is-checked");

			$selectedAvatar.parent().addClass("is-checked");

			$displayEl.attr("src", urlImg);
			$displayEl.show();

			$(elms.avatarUpload).val("");
		})
		.trigger("change");

	$(elms.inputNickname).on("input", function () {
		let name = $(this).val();
		if (name) {
			$(elms.submit).prop("disabled", false);
			$(".setupScreen__name").addClass("not-empty");
		} else {
			$(elms.submit).prop("disabled", true);
			$(".setupScreen__name").removeClass("not-empty");
		}
	});

	$(elms.avatarUpload).change(function () {
		const $this = $(this);
		const $avatars = $(elms.inputAvatar);
		$avatars.prop("checked", false);
		$avatars.parent().removeClass("is-checked");

		if ($this[0].files[0] != "undefined" && $this[0].files[0]) {
			$displayEl.show();
			readURL(this);
		} else {
			$avatars.first().prop("checked", true).trigger("change");
		}
	});

	$(elms.submit).on("click", function (e) {
		e.preventDefault();
		const $this = $(this);

		let formData = new FormData();

		//nickname
		formData.append("nickname", $(elms.inputNickname).val());

		//stock avatar
		const avatar = $(elms.inputAvatar.concat(":checked")).val();
		formData.append("avatar", avatar ? avatar : 0);

		//custom upload avatar
		const $customAvatar = $(elms.avatarUpload);
		if ($customAvatar[0].files[0] != "undefined" && $customAvatar[0].files[0]) {
			formData.append("custom_avatar", $customAvatar[0].files[0]);
		}

		$this.attr("disabled", true);

		bdjs.showLoading(() => {
			bdapi
				.post("member/submit-profile", formData)
				.then((response) => {
					$this.removeAttr("disabled");

					if(response.status !== 200 || !response.data || typeof response.data !== 'object') {
						bdjs.hideLoading()
						return alert('Avatar upload error, please contact admin')
					}

					if(!response.data.success) {
						bdjs.hideLoading()
						return alert(response.data.data.msg)
					}
					const data = response.data.data;

					if (data.redirect) {
						window.location.href = data.redirect;
						return false;
					}
				})
				.catch((error) => {
					console.log(error);
					$this.removeAttr("disabled");
					bdjs.hideLoading()
					alert('Avatar upload error, please contact admin')
				});
		})
	});


	/* Submit avatar on press enter */

	const $submitAvatar = $(elms.submit);

	$(document).on('keypress', function(e) {
		if(e.keyCode == 13 && !$submitAvatar.is(':disabled')){
			$submitAvatar.trigger('click');
		}
	});

	bdjs.hideLoading();
})(jQuery);
